import { LabelerURLQuery, LabelURLQuery } from '@/interface/url';
import { URLUtils } from '@@/utils';
import { createAbsoluteUrlFactoryCollection } from '@reversible/frontend-urls';
import { DEPLOY_ENV } from './env';
/**
 * url 的工厂函数组成的模块
 */
export const url = {
  home: (): string => '/home', // 主页
  // 标注
  label: ({ type, gender, c1, c2 }: LabelURLQuery, labelerQuery: LabelerURLQuery = {}): string =>
    URLUtils.joinParams(`/label/${type}/${gender}/${c1}/${c2}/`, labelerQuery),
  report: (): string => '/report/',
};

const WEB_ORIGIN = {
  local: 'https://www.reversible.dev',
  dev: 'https://www.reversible.dev',
  live: 'https://www.reversible.live',
  prod: 'https://www.reversible.com',
}[DEPLOY_ENV];
/**
 * absolute url for web
 */
export const webUrl = createAbsoluteUrlFactoryCollection(WEB_ORIGIN);
